import React from 'react';

import Slides from '../components/Slides';
import Middlebanner from '../components/Middlebanner';
import Adsslides from '../components/Adsslides';
import PopularProducts from './PopularProducts';
import ContactDelivery from './ContactDelivery';
import ViewReviews from '../pages/ViewReviews';


const Home = () => {
  return (
    <>
  

      <Slides />
      <Middlebanner/>
     
      <Adsslides />
     <ContactDelivery />
      <PopularProducts />
      
  


    </>
  );
};

export default Home;
